import type { AxiosInstance } from 'axios';
import type {
  EPickListResponse,
  GetEPickListsResponse,
  CreateEPickListRequest,
  UpdateEPickListRequest,
  EPickListTab,
  EPickListStatus
} from '../../types/EPickList';

export const EPickListService = (api: AxiosInstance) => ({
  /**
   * Get all EPickLists, optionally filtered by tab and/or status
   */
  getEPickLists: async (tab?: EPickListTab, status?: EPickListStatus): Promise<EPickListResponse[]> => {
    try {
      const params: Record<string, string> = {};
      if (tab) params.tab = tab;
      if (status) params.status = status;

      const response = await api.get<GetEPickListsResponse>('/epick-lists', { params });
      return response.data.lists;
    } catch (error) {
      console.error('Error getting epick-lists:', error);
      return [];
    }
  },

  /**
   * Get a single EPickList by ID
   */
  getEPickList: async (id: string): Promise<EPickListResponse | null> => {
    try {
      const response = await api.get<EPickListResponse>(`/epick-lists/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting epick-list:', error);
      return null;
    }
  },

  /**
   * Create a new EPickList
   */
  createEPickList: async (data: CreateEPickListRequest): Promise<EPickListResponse | null> => {
    try {
      const response = await api.post<EPickListResponse>('/epick-lists', data);
      return response.data;
    } catch (error) {
      console.error('Error creating epick-list:', error);
      return null;
    }
  },

  /**
   * Update an existing EPickList
   */
  updateEPickList: async (id: string, data: UpdateEPickListRequest): Promise<EPickListResponse | null> => {
    try {
      const response = await api.patch<EPickListResponse>(`/epick-lists/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating epick-list:', error);
      return null;
    }
  },

  /**
   * Delete an EPickList
   */
  deleteEPickList: async (id: string): Promise<boolean> => {
    try {
      await api.delete(`/epick-lists/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting epick-list:', error);
      return false;
    }
  }
});
